<template>
  <div>
    <van-cell-group>
      <!-- <van-cell title="姓名" v-if="formData.nickName" :value="formData.nickName" /> -->
      <van-cell title="姓名" v-if="(formData.username&&formData.username)||(formData.nickName&&formData.nickName)" :value="getValue(formData)" />
      <van-cell title="联系方式" :value="formData.phone" />
      <van-cell title="个人签名" :value="formData.motto" is-link @click="checkInfo('motto','修改个人签名')" />
      <div class="profiles">
        <van-cell title="简介" is-link :value="formData.profiles ? formData.profiles : defaultProfiles" @click="checkInfo('profiles','修改简介')" />
      </div>
      <van-cell title="职业照" :value="formData.img" is-link center>
        <template #default>
          <van-uploader :disabled="formData.status==1" :max-size="1000 * 1024" @oversize="onOversize" :after-read="afterRead">
            <img style="width:50%" :src="myImg" alt />
          </van-uploader>
        </template>
      </van-cell>
    </van-cell-group>
    <van-popup v-model="show">
        <van-nav-bar
            :title="showTitle"
            left-text="取消"
            right-text="完成"
            @click-left="onClickLeft"
            @click-right="reviseUser"
            />
        <van-field
        ref='fieldInput'
            clearable
            autofocus
            v-model="formData1[message]"
            rows="1"
            autosize
            type="textarea"
            />
    </van-popup>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast } from 'vant';
export default {
  data() {
    return {
      show: false,
      formData: {
        name: '张三',
        phone: '130000000',
        sign: '加入给你三天光明',
        synopsis: '昨天，今天，明天',
      },
      formData1:{},
      urlHead: '',
      myImg: require('./../../assets/img/product1.jpg'),
      userId: '',
      id: '',
      bodyId:'',
      message:'',
      showTitle:null,
      defaultProfiles:'例：本人来自黑龙江省哈尔滨市,曾2013年参军入伍.2016年开始从事贷款居间服务.至今凭借自身五年的贷款经验以及金融的专业知识在北京服务客户近300人.帮助过企业融资3个亿左右.你的事情交给我那就是一份使命.相信我.我会很快帮你解决难题'
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    getValue(formData){
        return formData?.username || formData?.nickName
    },
    onOversize(file) {
      Toast('文件大小不能超过 10MB');
    },
    afterRead(file) {
      let data = new FormData();
      data.append("file", file.file);
      data.append("bucketName", 'loan');
      this.$fetchPost(URL.upImg.url, data).then((res) => {
        this.bodyImg =  res.data.data.fileUrl
        this.bodyId = res.data.data.id
        this.myImg = res.data.data.fileUrl || require('./../../assets/img/mImg.png')
        this.formData1 = JSON.parse(JSON.stringify(this.formData))
        this.reviseUser()
      })
    },
    getUser() {
      let userId = localStorage.getItem('userid')
      this.$fetchGet(URL.getStaffsCard.url, { userId: userId }).then((res) => {
        this.formData = res.data.data
        if(this.formData.status=='1'){
          Toast('个人照片审核中')
        }else if(this.formData.status=='9'){
          Toast('个人照片未通过审核')
        }
        this.myImg = (!res.data.data.bodyImg ? require('./../../assets/img/mImg.png') : res.data.data.bodyImg)
        this.userId = res.data.data.userId
        this.id = res.data.data.id
      })
    },
    reviseUser() {
      let data = {
        userId: this.userId,
        id: this.id,

        oldBodyId: this.formData1.bodyId,
        motto: this.formData1.motto,
        profiles:this.formData1.profiles,
        status:this.bodyId ? 1 : 0,
        oldBodyImg:this.myImg

      }
      // this.$toFormData(data)
      this.$fetchPost(URL.getStaffsCard.url, data).then((res) => {
          if(res?.data?.code==20000){
            this.formData = res.data.data
            this.myImg = res.data.data.bodyImg
            this.show=false
            this.getUser()
          }
      })
    },
    checkInfo(tes,title){
        this.show=true
        this.showTitle=title
        this.formData1=JSON.parse(JSON.stringify(this.formData))
        this.message=tes
        if(this.message=='profiles'){
          if(!this.formData1.profiles){
            this.formData1.profiles=this.defaultProfiles
            return
          }
        }
        this.$nextTick(()=>{
            this.$refs.fieldInput.focus()
        })
    },
    onClickLeft(){
        this.show=false
        this.message=''
    },
  }
}
</script>

<style lang="less" scoped>
.van-popup{
  width: 100%;
  height: 100%;
}
.profiles{
  .van-cell{
    display: block;
    .van-cell__value{
      margin-top: 17.5px;
    text-align: justify;
    }
    .van-cell__right-icon{
      top: 10px;
    right: 15px;
    position: absolute;
    }
  }
}
</style>
